var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.brokerDataComputed)?_c('add-broker-component',{attrs:{"broker-data-prop":_vm.brokerDataComputed,"is-edit":_vm.isEdit}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }